import type { AirdropFarmingBotDto } from "@cede/types";
import type { BotTypeConfig } from "./bot-config-types";
import { SHARED_STATUS_STYLES } from "./bot-shared-styles";
import Decimal from "decimal.js";
import { CheckCircle2, Loader2, Pause, Play } from "lucide-react";

export const GRID_BOT_CONFIG: BotTypeConfig<AirdropFarmingBotDto> = {
  type: "grid",
  fieldAccessors: {
    getId: (bot) => bot.id,
    getStatus: (bot) => bot.status,
    getCreatedAt: (bot) => bot.createdAt,
    getPnl: (bot) => new Decimal(bot.realizedPnlUsdc).add(bot.unrealizedPnlUsdc).toNumber(),
    getVolumeMetric: (bot) => {
      const target = new Decimal(bot.targetVolumeUsdc);
      return target.gt(0) ? new Decimal(bot.totalVolumeUsdc).div(target).toNumber() : 0;
    },
  },
  statusPriority: {
    RUNNING: 0,
    PAUSED: 1,
    PENDING: 2,
    STOPPING: 3,
    ERROR: 4,
    STOPPED_MAX_LOSS: 5,
    COMPLETED: 6,
    STOPPED: 7,
  },
  statusStyles: {
    RUNNING: {
      icon: Play,
      label: "Running",
      color: "text-emerald-400",
      bg: "bg-emerald-400/10",
      border: "border-emerald-400/20",
    },
    PAUSED: {
      icon: Pause,
      label: "Paused",
      color: "text-amber-400",
      bg: "bg-amber-400/10",
      border: "border-amber-400/20",
    },
    PENDING: SHARED_STATUS_STYLES.PENDING,
    STOPPING: {
      icon: Loader2,
      label: "Stopping",
      color: "text-cede-text-tertiary",
      bg: "bg-cede-text-tertiary/10",
      border: "border-cede-text-tertiary/20",
      spin: true,
    },
    ERROR: SHARED_STATUS_STYLES.ERROR,
    STOPPED: SHARED_STATUS_STYLES.STOPPED,
    STOPPED_MAX_LOSS: SHARED_STATUS_STYLES.STOPPED_MAX_LOSS,
    COMPLETED: {
      icon: CheckCircle2,
      label: "Completed",
      color: "text-emerald-400",
      bg: "bg-emerald-400/10",
      border: "border-emerald-400/20",
    },
  },
  filterStatuses: ["RUNNING", "PAUSED", "PENDING", "STOPPING", "COMPLETED", "STOPPED", "STOPPED_MAX_LOSS", "ERROR"],
  sortOptions: [
    { key: "date", label: "Date", defaultDir: "desc" },
    { key: "status", label: "Status", defaultDir: "asc" },
    { key: "volume", label: "Volume %", defaultDir: "desc" },
    { key: "pnl", label: "PnL", defaultDir: "desc" },
  ],
  supportsDuplication: true,
};
